(function () {
  'use strict';

  var script = document.currentScript;
  var cartPath = script && script.getAttribute('data-cart-url');
  var pluginOrigin = script && script.getAttribute('data-plugin-origin');
  var designMode = script && script.getAttribute('data-design-mode') === 'true';
  var redirecting = false;
  var currentNonce = '';
  var retryTimer = null;
  var activeIframe = null;
  var widgetObserver = null;

  if (!cartPath || !pluginOrigin || designMode || (window.Shopify && window.Shopify.designMode)) return;

  var cartUrl;
  try {
    cartUrl = new URL(cartPath, window.location.origin);
    if (cartUrl.origin !== window.location.origin) return;
    cartUrl = cartUrl.toString();
  } catch (e) {
    return;
  }

  function createNonce() {
    var bytes = new Uint8Array(16);
    if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
      window.crypto.getRandomValues(bytes);
      return Array.prototype.map.call(bytes, function (byte) {
        return byte.toString(16).padStart(2, '0');
      }).join('');
    }
    return String(Date.now()) + '-' + Math.random().toString(16).slice(2);
  }

  function trackedCartUrl() {
    try {
      var target = new URL(cartUrl);
      target.searchParams.set('_cp_event', 'add_to_cart');
      target.searchParams.set('_cp_event_id', currentNonce || createNonce());
      return target.toString();
    } catch (e) {
      return cartUrl;
    }
  }

  function sendBridgeInit() {
    if (!activeIframe || !activeIframe.contentWindow || !currentNonce) return;
    try {
      activeIframe.contentWindow.postMessage({
        type: 'CUSPRINT_CART_BRIDGE_INIT',
        version: 1,
        nonce: currentNonce,
        cartUrl: cartUrl
      }, pluginOrigin);
    } catch (e) {}
  }

  function beginHandshake(iframe) {
    activeIframe = iframe;
    currentNonce = createNonce();
    window.clearInterval(retryTimer);
    sendBridgeInit();
    var attempts = 0;
    retryTimer = window.setInterval(function () {
      if (redirecting || attempts >= 4) {
        window.clearInterval(retryTimer);
        retryTimer = null;
        return;
      }
      attempts += 1;
      sendBridgeInit();
    }, 250);
  }

  function clearHandshake(iframe) {
    if (iframe && iframe !== activeIframe) return;
    activeIframe = null;
    currentNonce = '';
    window.clearInterval(retryTimer);
    retryTimer = null;
  }

  function bindProductIframe() {
    var iframe = document.getElementById('cuswebIframe');
    if (!iframe || iframe.__cusprintCartBridgeBound) return;
    iframe.__cusprintCartBridgeBound = true;
    iframe.addEventListener('load', function () {
      beginHandshake(iframe);
    });
    beginHandshake(iframe);
  }

  function publishWidgetContact(channel) {
    try {
      if (!window.Shopify || !Shopify.analytics || typeof Shopify.analytics.publish !== 'function') return;
      Shopify.analytics.publish('cusprint:widget_contact', {
        channel: channel,
        event_label: channel === 'whatsapp' ? '小组件-WhatsApp咨询' : '小组件-在线咨询',
        source: 'helpdesk_widget'
      });
    } catch (e) {}
  }

  function widgetChannel(target) {
    if (!target || typeof target.closest !== 'function') return '';
    var chatButton = target.closest('button.blue-btn');
    if (chatButton && /chat with us/i.test(chatButton.textContent || '')) return 'chat';
    var eventButton = target.closest('.event-button');
    if (eventButton && eventButton.querySelector('.btn-icon-name.whatsapp')) return 'whatsapp';
    return '';
  }

  function bindWidgetDocument(iframe) {
    try {
      var frameDocument = iframe.contentDocument;
      if (!frameDocument || frameDocument.__cusprintWidgetContactBound) return;
      frameDocument.__cusprintWidgetContactBound = true;
      frameDocument.addEventListener('click', function (event) {
        var channel = widgetChannel(event.target);
        if (channel) publishWidgetContact(channel);
      }, true);
    } catch (e) {}
  }

  function bindSupportWidget() {
    var iframe = document.getElementById('helpdesk-channel-iframe');
    if (!iframe) return;
    if (!iframe.__cusprintWidgetLoadBound) {
      iframe.__cusprintWidgetLoadBound = true;
      iframe.addEventListener('load', function () {
        bindWidgetDocument(iframe);
      });
    }
    bindWidgetDocument(iframe);
  }

  window.addEventListener('message', function (event) {
    var data = event.data || {};
    if (redirecting || event.origin !== pluginOrigin || !activeIframe) return;
    if (activeIframe.isConnected === false) {
      clearHandshake(activeIframe);
      return;
    }
    if (
      event.source === activeIframe.contentWindow &&
      data.type === 'CUSPRINT_CART_READY' &&
      data.version === 1 &&
      data.nonce === currentNonce
    ) {
      redirecting = true;
      window.clearInterval(retryTimer);
      window.location.assign(trackedCartUrl());
    }
  });

  bindProductIframe();
  bindSupportWidget();
  if (document.documentElement && typeof MutationObserver === 'function') {
    widgetObserver = new MutationObserver(bindSupportWidget);
    widgetObserver.observe(document.documentElement, { childList: true, subtree: true });
  }
  document.addEventListener('shopify:section:load', function () {
    bindProductIframe();
    bindSupportWidget();
  });
  document.addEventListener('shopify:section:unload', function (event) {
    if (!activeIframe || !event.target || typeof event.target.contains !== 'function') return;
    if (event.target.contains(activeIframe)) clearHandshake(activeIframe);
  });
}());
